import * as api from "./adapter";

export default {
  /**
   * Get detailed profile data for merge comparison
   * @param {number} userId - Primary user ID
   * @param {number} duplicateUserId - Secondary/duplicate user ID
   * @returns {Promise<*>}
   */
  getProfilesData: async (userId, duplicateUserId) => {
    const { data } = await api.read(`users/${userId}/duplicates/${duplicateUserId}/profiles_data`);
    return data;
  },

  /**
   * Get auto-merge configuration suggestion
   * @param {number} userId - Primary user ID
   * @param {number} duplicateUserId - Secondary/duplicate user ID
   * @returns {Promise<*>}
   */
  getAutoMergeConfig: async (userId, duplicateUserId) => {
    const { data } = await api.read(`users/${userId}/duplicates/${duplicateUserId}/auto_merge_config`);
    return data;
  },

  /**
   * Execute profile merge with given configuration
   * @param {number} userId - Primary user ID
   * @param {number} duplicateUserId - Secondary/duplicate user ID
   * @param {Object} config - Merge configuration
   * @returns {Promise<*>}
   */
  executeMerge: async (userId, duplicateUserId, config) => {
    const { data } = await api.create({
      type: 'merge_execution',
      attributes: {
        merge_mode: 'manual',
        manual_configuration: config,
        duplicate_user_id: duplicateUserId
      }
    }, { 
      url: `users/${userId}/duplicates/${duplicateUserId}/execute_merge`
    });
    return data;
  },

  /**
   * Mark profiles as not duplicates
   * @param {number} userId - Primary user ID
   * @param {number} duplicateUserId - Secondary/duplicate user ID
   * @returns {Promise<*>}
   */
  markNotDuplicate: async (userId, duplicateUserId) => {
    const { data } = await api.create({
      type: 'not_duplicate_marker',
      attributes: {
        duplicate_user_id: duplicateUserId
      }
    }, { 
      url: `users/${userId}/duplicates/${duplicateUserId}/mark_not_duplicate`
    });
    return data;
  },

  /**
   * Get list of duplicates for a user
   * @param {number} userId - User ID
   * @returns {Promise<*>}
   */
  showDuplicates: async (userId) => {
    const { data } = await api.read(`users/${userId}/show_duplicates`);
    return data;
  },

  /**
   * Search for duplicates for a user
   * @param {number} userId - User ID
   * @returns {Promise<*>}
   */
  searchDuplicates: async (userId) => {
    const { data } = await api.create({
      type: 'duplicate_search',
      attributes: {}
    }, { 
      url: `users/${userId}/search_duplicates`
    });
    return data;
  }
};